<template>
  <div class="live live02">
    <div class="inner">
      <Title>
        <template #title>
          学び・体験・遊びLIVE
        </template>
      </Title>
      <div class="description">
        <p>
          全国のママ主催者による楽しい「学び・体験・遊びLIVE」<br>
          ひとりで、親子で、気軽に参加しよう♪
        </p>
      </div>
      <!-- <div
        class="comingsoon"
        v-if="month === '202008'"
      >
        <figure>
          <img src="/img/logo.svg">
          <figcaption>
            COMING SOON<br>
            お楽しみに♪
          </figcaption>
        </figure>
      </div>
      <div v-else> -->
        <div class="live-programs"
        v-if="month === '202008'"
        >
          <LiveProgram08
            v-for="program in providerLive"
            :key="program.id"
            :program="program"
            liveType="provider"
            :month="month"
          />
        </div>
        <div class="live-programs"
        v-if="month === '202007'"
        >
          <LiveProgram07
            v-for="program in providerLive"
            :key="program.id"
            :program="program"
            liveType="provider"
            :month="month"
          />
        </div>
        <div class="live-programs"
        v-if="month === '202006'"
        >
          <LiveProgram06
            v-for="program in providerLive"
            :key="program.id"
            :program="program"
            liveType="provider"
            :month="month"
          />
        </div>
        <infinite-loading
          :identifier="infiniteId"
          @infinite="infiniteHandler"
        >
          <div slot="no-more"></div>
          <div slot="no-results"></div>
          <div slot="spinner">
              <Spinner />
            </div>
        </infinite-loading>
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import Title from '@/components/atoms/Title.vue'
import LiveProgram06 from '@/components/molecules/202006/LiveProgram.vue'
import LiveProgram07 from '@/components/molecules/202007/LiveProgram.vue'
import LiveProgram08 from '@/components/molecules/202008/LiveProgram.vue'
import InfiniteLoading from 'vue-infinite-loading'
import Spinner from '@/components/atoms/Spinner.vue'
export default {
  props: {
    month: {
      type: String,
      required: true
    }
  },
  components: {
    Title,
    LiveProgram06,
    LiveProgram07,
    LiveProgram08,
    InfiniteLoading,
    Spinner
  },
  data: () => ({
    infiniteId: +new Date(),
    providerLive: []
  }),
  computed: {
    ...mapState([
      'dateTab',
      'lastProviderSnapshots'
    ]),
    ...mapGetters([
      'providerLive0624',
      'providerLive0625',
      'providerLive0728',
      'providerLive0729',
      'providerLive0827',
      'providerLive0828'
    ])
  },
  methods: {
    ...mapActions([
      'getProviderLivePrograms'
    ]),
    async infiniteHandler ($state) {
      await this.getProviderLivePrograms({
        month: this.month
      })
        .then(() => {
          this.setLive()
          $state.loaded()
        })
        .catch(() => {
          $state.complete()
        })
    },
    setLive () {
      if (this.dateTab === '2020-06-24') {
        this.providerLive = this.providerLive0624
      } else if (this.dateTab === '2020-06-25') {
        this.providerLive = this.providerLive0625
      } else if (this.dateTab === '2020-07-28') {
        this.providerLive = this.providerLive0728
      } else if (this.dateTab === '2020-07-29') {
        this.providerLive = this.providerLive0729
      } else if (this.dateTab === '2020-08-27') {
        this.providerLive = this.providerLive0827
      } else {
        this.providerLive = this.providerLive0828
      }
    }
  },
  watch: {
    dateTab: {
      handler (val, old) {
        this.setLive()
      }
    }
  },
  mounted () {
    console.log(this.providerLive0827)
  }
}
</script>

<style lang="sass" scoped>
.live02
  background-color: #fff
  padding: 25px 0
</style>
